<template>
  <div class="hs-popup-mask-box">
    <transition name="hs-popup-mask">
      <div
        class="hs-popup-mask"
        v-show="show"
        @click="$emit('update:show', false)"
      ></div>
    </transition>
    <transition name="datepicker">
      <div
        class="hs-datepicker"
        :class="{ 'ios-safe-bottom': !isEMobile7Browser }"
        v-if="show"
        @click.stop
      >
        <hs-date-header
          :title="$t('SelectDate')"
          @close="$emit('update:show', false)"
        />
        <div class="tips" v-if="isBeforeDawn">
          {{ $t("ItIsNowPastZeroOclock_x", "function", [YesterdayCloseHours]) }}
        </div>
        <div class="tips" v-else-if="tips">{{tips}}</div>
        <hs-scroll ref="tableView" class="tableView">
          <ul>
            <li
              class="cell"
              v-for="n in isBeforeDawn ? 13 : 12"
              :key="n"
              :id="`cell${_getMonthBarsMonth(n)}`"
            >
              <div class="moutn-bar">
                {{
                  $t(
                    `${_getMonthBarsYear(n)}-${_getMonthBarsMonth(n)}`,
                    "date",
                    ["yyyy年MM月", "MM yyyy"]
                  )
                }}
              </div>
              <div class="week-bar">
                <div class="item" v-for="(item, index) in week" :key="index">
                  {{ item }}
                </div>
              </div>
              <div class="day-bar">
                <div
                  class="disabledItem"
                  style="visibility: hidden"
                  v-for="number in _getPreMonthDay(
                    _getMonthBarsYear(n),
                    _getMonthBarsMonth(n)
                  )"
                  :key="`pre${number}`"
                >
                  {{ number }}
                </div>
                <div
                  :class="[
                    {
                      weekendItem: _isWeekend(
                        _getMonthBarsYear(n),
                        _getMonthBarsMonth(n),
                        number
                      ),
                    },
                    _isOverdue(
                      _getMonthBarsYear(n),
                      _getMonthBarsMonth(n),
                      number
                    ) ||
                    (noValue(toDate) &&
                      _addZero(
                        _getMonthBarsYear(n),
                        _getMonthBarsMonth(n),
                        number
                      ) > maxToData) ||
                    _addZero(
                      _getMonthBarsYear(n),
                      _getMonthBarsMonth(n),
                      number
                    ) > maxDate
                      ? 'disabledItem'
                      : 'item',
                    {
                      thisItem:
                        _isFromDate(
                          _getMonthBarsYear(n),
                          _getMonthBarsMonth(n),
                          number
                        ) ||
                        _isToDate(
                          _getMonthBarsYear(n),
                          _getMonthBarsMonth(n),
                          number
                        ),
                    },
                    {
                      rangeItem: _isRangeDate(
                        _getMonthBarsYear(n),
                        _getMonthBarsMonth(n),
                        number
                      ),
                    },
                  ]"
                  v-for="number in _getDayNumber(
                    _getMonthBarsYear(n),
                    _getMonthBarsMonth(n)
                  )"
                  :key="`this${number}`"
                  @click="
                    _select(_getMonthBarsYear(n), _getMonthBarsMonth(n), number)
                  "
                >
                  <!-- 节日 -->
                  <span
                    class="holiday-span no-wrap"
                    v-if="
                      _setHoliday(
                        _getMonthBarsYear(n),
                        _getMonthBarsMonth(n),
                        number
                      )
                    "
                    >{{
                      _setHoliday(
                        _getMonthBarsYear(n),
                        _getMonthBarsMonth(n),
                        number
                      )
                    }}</span
                  >
                  <span
                    class="mark"
                    v-else-if="_setYesterday(_getMonthBarsMonth(n), number, _getMonthBarsYear(n))"
                    >{{ $t("EarlyThisMorning") }}</span
                  >
                  <span
                    class="mark"
                    v-else-if="
                      isBeforeDawn &&
                      _isToday(
                        _getMonthBarsYear(n),
                        _getMonthBarsMonth(n),
                        number
                      )
                    "
                    >{{ $t("AtNoonToday") }}</span
                  >
                  <span class="mark" v-else>&nbsp;</span>
                  <div
                    v-if="
                      birthday &&
                      _addZero(
                        _getMonthBarsYear(n),
                        _getMonthBarsMonth(n),
                        number
                      ).endsWith(birthday)
                    "
                    class="birthday"
                    :style="{backgroundImage: `url(${require('@/assets/image/base/date-picker/birthday.png')})`}"
                  >
                    <span
                      v-if="
                        _setRestDay(
                          _getMonthBarsYear(n),
                          _getMonthBarsMonth(n),
                          number
                        )
                      "
                      class="rest"
                      :type="language"
                      >{{ $t("Rest") }}</span
                    >
                    <span
                      v-if="
                        _setWorkDay(
                          _getMonthBarsYear(n),
                          _getMonthBarsMonth(n),
                          number
                        )
                      "
                      class="work"
                      :type="language"
                      >{{ $t("Work") }}</span
                    >
                  </div>
                  <p class="day-cell" v-else>
                    <!-- {{_isToday(_getMonthBarsYear(n), _getMonthBarsMonth(n), number) ? $t('Today') : number}} -->
                    <!--凌晨入住修改 今天 19 如果是凌晨入住 18 19 展示 19 19， 如果不是凌晨入住 不在凌晨入住时间范围内 则18 19 展示 18 今天-->
                    <template
                      v-if="
                        isBeforeDawn &&
                        _isToday(
                          _getMonthBarsYear(n),
                          _getMonthBarsMonth(n),
                          number
                        )
                      "
                    >
                      {{ number }}
                    </template>
                    <template
                      v-else-if="_setYesterday(_getMonthBarsMonth(n), number, _getMonthBarsYear(n))"
                    >
                      {{ _getNextDay(n, number) }}
                    </template>
                    <template v-else>
                      {{
                        _isToday(
                          _getMonthBarsYear(n),
                          _getMonthBarsMonth(n),
                          number
                        )
                          ? $t("Today")
                          : number
                      }}
                    </template>

                    <span
                      v-if="
                        _setRestDay(
                          _getMonthBarsYear(n),
                          _getMonthBarsMonth(n),
                          number
                        )
                      "
                      class="rest"
                      :type="language"
                      >{{ $t("Rest") }}</span
                    >
                    <span
                      v-if="
                        _setWorkDay(
                          _getMonthBarsYear(n),
                          _getMonthBarsMonth(n),
                          number
                        )
                      "
                      class="work"
                      :type="language"
                      >{{ $t("Work") }}</span
                    >
                  </p>
                  <span
                    class="mark"
                    v-if="
                      _isFromDate(
                        _getMonthBarsYear(n),
                        _getMonthBarsMonth(n),
                        number
                      )
                    "
                    >{{ $t("CI") }}</span
                  >
                  <span
                    class="mark"
                    v-else-if="
                      _isToDate(
                        _getMonthBarsYear(n),
                        _getMonthBarsMonth(n),
                        number
                      )
                    "
                    >{{ $t("CO") }}</span
                  >
                  <span class="mark" v-else>&nbsp;</span>
                </div>
                <div
                  class="disabledItem"
                  style="visibility: hidden"
                  v-for="number in _getNextMonthDay(
                    _getMonthBarsYear(n),
                    _getMonthBarsMonth(n)
                  )"
                  :key="`next${number}`"
                >
                  {{ number }}
                </div>
              </div>
            </li>
            <div style="height: 20px"></div>
          </ul>
        </hs-scroll>
      </div>
    </transition>
  </div>
</template>
<script type="text/ecmascript-6">
import Vue from 'vue'
import HsScroll from 'base/hs-scroll/hs-scroll'
import {mapGetters} from 'vuex';
// import setHoliday from './holiday.js'
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    fromDate: {
      type: String,
      default: Vue.prototype.beTime(new Date())
    },
    toDate: {
      type: String,
      default: Vue.prototype.beTime(new Date().setDate(new Date().getDate() + 1))
    },
    overdueDate: {
      type: String,
      default: Vue.prototype.beTime(new Date())
    },
    maxDate: {
      type: String,
      default: null
    },
    YesterdayCloseHours: {
      type: [String, Number],
      default: 0
    },
    tips: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapGetters([
      'isEMobile7Browser'
    ]),
    currentFromDate: {
      get: function() {
        return this.fromDate
      },
      set: function(val) {
        return this.$emit('update:fromDate', val)
      }
    },
    currentToDate: {
      get: function() {
        return this.toDate
      },
      set: function(val) {
        return this.$emit('update:toDate', val)
      }
    },
    maxToData() {
      // let res = this.beTime(new Date(this.fromDate).setDate(new Date(this.fromDate).getDate() + 28)) // 最多选择28晚
      let res = this.beTime(new Date(this.fromDate).setDate(new Date(this.fromDate).getFullYear() + 2)) // 不限制最大可选时间
      return res
    },
    isBeforeDawn() {
      return this._isBeforeDawn()
    }
  },
  watch: {
    show(val) {
      if (val) {
        /** 初始化读取节假日数据 */
        if (window.localStorage.CALENDAR) {
          let list = JSON.parse(window.localStorage.CALENDAR)

          // 节假日
          this.calendar = new Map(list.filter(v => v.DayType !== 3).map((value, key) => [this.beTime(value.Date), value]))
          this.calendarRest = new Map(list.filter(v => v.DayType === 1).map((value, key) => [this.beTime(value.Date), value]))
          this.calendarWork = new Map(list.filter(v => v.DayType === 2).map((value, key) => [this.beTime(value.Date), value]))

          // 生日
          let birthday = list.filter(v => v.DayType === 3)
          this.birthday = (birthday && birthday[0]) ? `${this.beTime(birthday[0].Date, 'MM-dd')}` : ''
        }

        this.historyFromDate = this.fromDate
        this.historyToDate = this.toDate
        setTimeout(() => {
          this.$refs.tableView && this.$refs.tableView.refresh();
          let res = new Date(this.fromDate).getMonth() + 1
          this.$refs.tableView.scrollToElement(`#cell${res}`, 300)
        }, 20)
      } else {
        if (this.noValue(this.currentToDate)) {
          this.currentFromDate = this.historyFromDate
          this.currentToDate = this.historyToDate
        }
      }
    }
  },
  data() {
    return {
      week: [this.$t('WeekSun'), this.$t('WeekMon'), this.$t('WeekTues'), this.$t('WeekWed'), this.$t('WeekThur'), this.$t('WeekFri'), this.$t('WeekSat')],
      monthDay: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
      thatYear: new Date().getFullYear(),
      thatMouth: new Date().getMonth(),
      nextYear: new Date().getFullYear() + 1,

      // thatYear: 2021,
      // thatMouth: 8,
      // nextYear: 2022,

      historyFromDate: '',
      historyToDate: '',
      calendar: new Map(), // 节假日数据
      calendarRest: new Map(), // 非正常休息日数据
      calendarWork: new Map(), // 非正常工作日数据
      birthday: ''
    }
  },
  methods: {
    /** 设置今天凌晨 */
    _setYesterday(n, number, y) {
      let yesterday = this.getNewDate(new Date(), 0, 0, -1)
      let m = n
      let year = y || (n < 13 ? this.thatYear : this.nextYear)
      if (n === 0) {
        year = this.thatYear - 1
      }
      let day = `${year}-${m >= 10 ? m : '0' + m}-${number >= 10 ? number : '0' + number}`
      if (this.beTime(day) === this.beTime(yesterday) && this.isBeforeDawn) {
        return true
      }
      return false
    },

    /** 是否可以下昨天的单 */
    _isCanBookPreDay(date) {
      let yesterday = this.getNewDate(new Date(), 0, 0, -1)
      if (this.beTime(date) === this.beTime(yesterday) && this.isBeforeDawn) {
        return true
      }
      return false
    },

    /** 是否有凌晨下单时间点 且当前时间小于凌晨时间点 */
    _isBeforeDawn() {
      let hours = new Date().getHours()
      return this.YesterdayCloseHours > 0 && hours < this.YesterdayCloseHours
    },

    /** 获取明天 */
    _getNextDay(n, number) {
      return new Date().getDate()
    },

    /** 设置节日 */
    _setHoliday(year, month, day) {
      let key = this._addZero(year, month, day)
      let res = this.calendar.get(key)
      return res ? res.Title : ''
    },

    /** 设置工作日 */
    _setWorkDay(year, month, day) {
      let key = this._addZero(year, month, day)
      let res = this.calendarWork.get(key)
      return res
    },

    /** 设置休息日 */
    _setRestDay(year, month, day) {
      let key = this._addZero(year, month, day)
      let res = this.calendarRest.get(key)
      return res
    },

    // 获取某年某月一号的星期数值
    _getFirstDayWeek(year, month) {
      return new Date(year, month - 1, 1).getDay()
    },
    // 获取某年某月最后一天的星期数值
    _getLastDayWeek(year, month) {
      return new Date(year, month - 1, this._getDayNumber(year, month)).getDay()
    },
    // 是否为周末
    _isWeekend(year, month, day) {
      let res = new Date(year, month - 1, day).getDay()
      return res === 0 || res === 6
    },
    // 获取这个月bar中上个月的尾部天数数组
    _getPreMonthDay(year, month) {
      let preYear = year
      let preMonth = month
      if (month === 1) {
        preYear--
        preMonth = 12
      } else {
        preMonth--
      }
      let number = this._getDayNumber(preYear, preMonth)
      let length = this._getFirstDayWeek(year, month)
      let list = []
      for (let i = 0; i < length; i++) {
        list.push(number - (length - i) + 1)
      }
      return list
    },
    // 获取这个月bar中下个月的尾部天数数组
    _getNextMonthDay(year, month) {
      let length = 6 - this._getLastDayWeek(year, month)
      let list = []
      for (let i = 0; i < length; i++) {
        list.push(i + 1)
      }
      return list
    },
    // 根据年月，知道这个月有几天
    _getDayNumber(year, month) {
      return this._isLeapYeat(year) && month === 2 ? 29 : (this.monthDay[month - 1] || 31)
    },
    // 获取年月栏的年数值
    _getMonthBarsYear(n) {
      if (this.isBeforeDawn) { // 针对酒店凌晨下单 兼容显示13个月的日历
        n = n - 1
      }
      if ((this.thatMouth + n) === 0) {
        return this.thatYear -1
      }
      return (this.thatMouth + n) < 13 ? this.thatYear : this.nextYear
    },
    // 获取年月栏的月数值
    _getMonthBarsMonth(n) {
      if (this.isBeforeDawn) { // 针对酒店凌晨下单 兼容显示13个月的日历
        n = n - 1
      }
      if ((this.thatMouth + n) === 0) {
        return 12
      }
      return (this.thatMouth + n) < 13 ? (this.thatMouth + n) : (this.thatMouth + n - 12)
    },
    // 是否为闰年
    _isLeapYeat(year) {
      return (year % 100 == 0 ? (year % 400 == 0 ? true : false) : (year % 4 == 0 ? year : false)) // eslint-disable-line
    },
    // 日期是否已经过期
    _isOverdue(year, month, day) {
      if (this._setYesterday(month, day, year)) {
        return false
      }
      let overdueDate = (this.overdueDate === null) ? this.beTime(new Date()) : this.overdueDate
      let that = this._addZero(year, month, day)
      return that < overdueDate
    },
    // 是否为选择的入住日期,用于高亮css
    _isFromDate(year, month, day) {
      let res = this._addZero(year, month, day)
      return res === this.currentFromDate
    },
    // 是否为选择的离店日期,用于高亮css
    _isToDate(year, month, day) {
      let res = this._addZero(year, month, day)
      return res === this.currentToDate
    },
    _isToday(year, month, day) {
      let res = this._addZero(year, month, day)
      return res === this.beTime(new Date())
    },
    _isRangeDate(year, month, day) {
      let res = this._addZero(year, month, day)
      return this.currentFromDate && res > this.currentFromDate && res < this.currentToDate
    },
    // 选择
    _select(year, month, day) {
      let res = this._addZero(year, month, day)
      if (
        (!this.noValue(this.currentFromDate) && (!this.noValue(this.currentToDate) || res < this.currentFromDate)) ||
        this.noValue(this.currentFromDate)
      ) {
        this.currentFromDate = ''
        this.currentToDate = ''
        this.currentFromDate = res
      } else if (res > this.currentFromDate) {
        this.currentToDate = res
        this.$emit('update:show', false)
      }
    },
    _addZero(year, month, day) {
      return `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`
    }
  },
  components: {
    HsClose: () => import('base/hs-close/hs-close'),
    HsDateHeader: () => import('base/hs-date-picker/hs-date-header'),
    HsScroll
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
@import '~common/stylus/popup-mask.styl'
.hs-datepicker
  width 100%
  height 95%
  position fixed
  top 5%
  left 0
  background-color $color_white
  z-index 99
  border-top-left-radius 10px
  border-top-right-radius 10px
  overflow hidden
  &.ios-safe-bottom
    height calc(95% - constant(safe-area-inset-bottom))
    height calc(95% - env(safe-area-inset-bottom))
  >.tips
    @extend .flex-center
    width 100%
    height 40px
    background $color_yellow_background_warning
    color $color_orange_text_warning
    font-size .8rem
    line-height 1.2em
    transition all 500ms
  >.tableView
    width 100%
    height calc(100% - 50px)
    overflow hidden
    .cell
      width 100%
      border-top 10px solid $color_gray_background_0
      padding 10px 0
      >.moutn-bar
        @extend .flex-row
        @extend .flex-start
        width 100%
        height 30px
        font-weight bold
        padding 0 10px
      >.week-bar
        @extend .flex-row
        @extend .flex-between
        width 100%
        border-bottom 1px solid $color_gray_layer
        margin-bottom 2px
        >.item
          @extend .flex-center
          width: 14.28571%
          height 2.5rem
          font-size 0.8rem
      >.day-bar
        @extend .flex-row
        @extend .flex-between
        flex-wrap wrap
        >.disabledItem
        >.item
          @extend .flex-column
          @extend .flex-center
          width: 14.28571%
          height 4rem
          font-size 0.8rem
          >.day-cell
            font-size 1rem
            font-weight bold
            margin 3px 0
            position relative
            >.rest
            >.work
              @extend .flex-center
              position absolute
              right -12px
              top 0
              font-size 10px
              color $color_theme
              font-weight bold
              transform scale(0.7)
              transform-origin right
              &[type='EN'],&[type='JAP']
                right -16px
            >.work
              color $color_black_text_0
          >.holiday-span
            font-size 0.7rem
            width 100%
            height 1em
            text-align center
          >.mark
            font-size 0.7rem
            width 100%
            // height 1em
            text-align center
          >.birthday
            width 16px
            height 16px
            background url(@/assets/image/base/date-picker/birthday.png) no-repeat
            background-size 100% 100%
            margin 3px 0
            position relative
            >.rest
            >.work
              @extend .flex-center
              position absolute
              right -12px
              top 0
              font-size 10px
              color $color_theme
              font-weight bold
              transform scale(0.7)
              transform-origin right
              &[type='EN'],&[type='JAP']
                right -16px
            >.work
              color $color_black_text_0
        >.disabledItem
          color $color_gray_text !important
          pointer-events none !important
          >p
            >.rest
            >.work
              color $color_gray_text
        >.weekendItem
          color $color_theme
        >.thisItem
          background-color $color_theme
          color $color_white
          border-radius 2px
          >.day-cell
            >.rest
            >.work
              color $color_white
        >.rangeItem
          background-color $color_red_background_0 !important
          color $color_black_text_0 !important
.datepicker-enter-active
.datepicker-leave-active
  transition: all 300ms
.datepicker-enter
.datepicker-leave-to
  transform translateY(100%)
</style>
